import React, { useState } from 'react';
import { KatSpinner } from '@amzn/katal-react';
import TRBStatusTable from 'src/features/components/trb/TRBStatusTable';
import TRBMaxRiskTable from 'src/features/components/trb/TRBMaxRiskTable';
import {
    useTRBStatusTable,
    useTRBMaxRiskTable,
    useTRBFCProcessingTimes,
} from 'src/features/hooks/useTRBData';
import 'src/features/components/trb/trb.css';

const TRBPage: React.FC = () => {
    const [slaFilter, setSlaFilter] = useState(true);

    const { data: statusTableData, isLoading: statusLoading, isError: statusError, dataUpdatedAt: statusUpdatedAt } = useTRBStatusTable();
    const { data: maxRiskTableData, isLoading: maxRiskLoading, isError: maxRiskError, dataUpdatedAt: maxRiskUpdatedAt } = useTRBMaxRiskTable();
    const { data: fcProcessingTimes, isLoading: fcProcessingLoading, isError: fcProcessingError } = useTRBFCProcessingTimes();

    const formatUpdated = (ts?: number) =>
        ts ? new Date(ts).toUTCString().replace('GMT', '(UTC)') : '';

    return (
        <div className="trb-page">
            <div className="trb-content">
                {/* Status Table Section */}
                <div className="trb-section">
                    <h2 className="trb-section-title">Current Active TRBs</h2>
                    <p className="trb-last-updated">Last Updated: {formatUpdated(statusUpdatedAt)}</p>
                    <label className="trb-filter-label">
                        <input
                            type="checkbox"
                            checked={slaFilter}
                            onChange={(e) => setSlaFilter(e.target.checked)}
                        />
                        {' '}Display only TRBs after FT SLA
                    </label>
                    {(statusError || fcProcessingError) ? (
                        <div className="trb-error">Failed to load Active TRBs. Please try again later.</div>
                    ) : (statusLoading || fcProcessingLoading) ? (
                        <div className="trb-loading">
                            <KatSpinner size="large" />
                            <p>Loading Active TRBs, Please Wait...</p>
                        </div>
                    ) : (
                        <TRBStatusTable
                            statusTableData={statusTableData ?? []}
                            slaFilter={slaFilter}
                            slaData={fcProcessingTimes ?? {}}
                        />
                    )}
                </div>

                {/* Max Risk Table Section */}
                <div className="trb-section">
                    <h2 className="trb-section-title">All FC&apos;s Current Max Risk</h2>
                    <p className="trb-last-updated">Last Updated: {formatUpdated(maxRiskUpdatedAt)}</p>
                    {maxRiskError ? (
                        <div className="trb-error">Failed to load Max Risk data. Please try again later.</div>
                    ) : maxRiskLoading ? (
                        <div className="trb-loading">
                            <KatSpinner size="large" />
                            <p>Loading Max Risk Data, Please Wait...</p>
                        </div>
                    ) : (
                        <TRBMaxRiskTable maxRiskTableData={maxRiskTableData ?? []} />
                    )}
                </div>
            </div>
        </div>
    );
};

export default TRBPage;
